import { render, staticRenderFns } from "./CollaborationAccountAdd.vue?vue&type=template&id=9299bf5e&scoped=true&"
import script from "./CollaborationAccountAdd.vue?vue&type=script&lang=js&"
export * from "./CollaborationAccountAdd.vue?vue&type=script&lang=js&"
import style0 from "./CollaborationAccountAdd.vue?vue&type=style&index=0&id=9299bf5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9299bf5e",
  null
  
)

export default component.exports